import React from 'react'
import AppDispatcher from '../dispatcher/app-dispatcher'

const EventEmitter = require('events')
const CHANGE_EVENT = 'change';

class ProductStore {
    constructor(appDispatcher, eventEmitter) {
        this.dispatcherIndex = appDispatcher.register(this.register.bind(this))
        this.eventEmitter = eventEmitter
        this._availableProducts = {};
    }

    /**
     * Register listener to the Store with callback to be called when a change is emitted from the ProductStore
     * @param {function} callback
     */
    addChangeListener (callback) {
        // Adds listener to ProductStore (addListener is an EventEmitter function )
        this.eventEmitter.addListener(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.eventEmitter.removeListener(CHANGE_EVENT, callback);
    }

    emitChange () {
        this.eventEmitter.emit(CHANGE_EVENT);
    }

    // Method that gets the current product list for the editor
    getProducts () {
        return this._availableProducts;
    }

    getProductById (id) {
        return this._availableProducts[id];
    }

    register(payload) {
        var action = payload.action;
        switch (action.actionType) {
            case 'addProductToStore':
                this._availableProducts[action.product.getId()] = action.product;
                this.emitChange();
                break;
        }

        return true;
    }    
}

const store = new ProductStore(AppDispatcher, new EventEmitter())

export default store;
export {ProductStore as ProductStoreClass} 
